@if (optimizedImage(); as optimizedImage) {
<div class="w-image-optimized" [class.responsive]="optimizedImage.isResponsive">
	<ng-template #imageTemplate>
		<img
			[class.clickable]="dialogPreviewImage() ? true : false"
			[class.box-shadow-featured]="boxShadow() === 'featured'"
			(click)="openOptimizedImageDialog($event, optimizedImage)"
			[ngStyle]="optimizedImage.styles"
			[height]="optimizedImage.height"
			[width]="optimizedImage.width"
			[ngSrc]="optimizedImage.src"
			[alt]="optimizedImage.alt"
			[priority]="optimizedImage.priority"
		/>
	</ng-template>

	<!-- The reason for these condition is that Angular would throw an exception if the width / height changes
	 This usually happens when screen size changes and so this handles most scenarios of that happening.
	 In ideal case it should be handled by using the same size -->
	@if (isMobileView()) { <ng-template [ngTemplateOutlet]="imageTemplate"></ng-template> } @else if (isTabletView()){
	<ng-template [ngTemplateOutlet]="imageTemplate"></ng-template>
	} @else {
	<ng-template [ngTemplateOutlet]="imageTemplate"></ng-template>
	}
</div>
} @if (avatarImage(); as avatarImage) {
<div>
	<lib-avatar-from-name
		[borderRadius]="borderRadius()"
		[isRound]="isRound()"
		[cssStyles]="avatarImage.styles"
		[name]="avatarImage.name"
		[size]="avatarImage.size"
	></lib-avatar-from-name>
</div>
}
